<template><TriggerForm :formItems="formItems" /></template>

<script>
import { actionContextNode, editedWorkflowVersion, editWorkflowHasInstallable } from '@/store/modules/selectedWorkflow/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import ElementContextMixin from './ElementContextMixin';
import { generalConfigurationId, userSpecificConfigurationId } from '@/store/modules/selectedWorkflow/modules/configurations/getters';
import FormItem from './FormItem.vue';
import FormItemCredentialsSelector from './FormItemCredentialsSelector.vue';
import PlacementService from '@/utils/placement-service';
import { CredentialsTypes } from '@ply-io/ply-front-shared-utilities';
import TriggerForm from './TriggerForm.vue';

export default {
	name: 'AddOnTriggerFormDataProvider',
	mixins: [ElementContextMixin],
	computed: {
		...mapGettersShorthand({
			editedWorkflowVersion,
			editWorkflowHasInstallable,
			userSpecificConfigurationId,
			generalConfigurationId,
			actionContextNode,
		}),
		formItems() {
			return [
				{ component: FormItem, listeners: {}, props: { item: { title: 'Feature Type', value: 'Add-on' } } },
				{ component: FormItem, listeners: {}, props: { item: { title: 'App', value: this.service.service_name } } },
				{
					component: FormItemCredentialsSelector,
					listeners: {},
					props: {
						workflowVersion: this.editedWorkflowVersion,
						disableRealProfiles: this.editWorkflowHasInstallable,
						serviceId: this.placement.service,
						serviceVersionId: this.placement.version,
						configurationId: this.configurationId,
						effectedNode: this.actionContextNode,
					},
				},
				{
					component: FormItem,
					listeners: {},
					props: { item: { title: 'Context', value: PlacementService.getFullItemName(this.placement) } },
				},
				{
					component: FormItem,
					listeners: {},
					props: { item: { title: 'Element', value: PlacementService.getAddOnType(this.placement, this.element.type) } },
				},
			];
		},
		configurationId() {
			if (!this.editedWorkflowVersion.app_credentials_configuration) {
				return null;
			}
			return this.editedWorkflowVersion.app_credentials_configuration.credentials_type === CredentialsTypes.ProfileBased
				? this.userSpecificConfigurationId
				: this.generalConfigurationId; // CredentialsTypes.AccountBased
		},
	},
	components: { TriggerForm },
};
</script>

<style lang="scss" scoped></style>
